import React, { useEffect, useState } from 'react';
import paymentService from '../../../services/payment/payment.service';
import { Badge, Button, Image, Tag } from 'antd';
import { Link } from 'react-router-dom';
import EntranceMotion from '../../../helpers/components/entrance_motion';
import { CloseOutlined } from '@ant-design/icons';
import globalHelper from '../../../helpers/functions/global.helper';
import { useSelector } from 'react-redux';

const PaymentResultFail = ({ticket}) => {
    const ticketRedux = useSelector(state => state.ticket);
    const currency = ticketRedux?.park?.currency?.symbol;
    const [state, setState] = useState({
        link_loading : false,
    })

    const goToPayment = async () => {
        setState(state => ({...state, link_loading : true}));
        const ticket_id = ticket?.ticket_id;
        const paymentLinkResponse = await paymentService.generatePaymentLink(ticket?.park?.park_code, {
            ticket_id
        }).catch(err =>{
            setState(state => ({...state, link_loading : false}));
        });


        setState(state => ({...state, link_loading : false}));
        window.location.href = paymentLinkResponse?.url;
    }

    return (
        <>
            <div className='mobile-padding-24' style={{ width:'100%'}}>
                <div style={{position:'relative'}}>
                    <EntranceMotion initialY={-100} duration={0.5}>
                        <Badge count={
                                <div>
                                    <EntranceMotion initialY={-50} duration={0.5} delay={0.2}>
                                        <Tag
                                        color={'red'} 
                                        style={{
                                            border:'none', 
                                            textAlign:'center', 
                                            borderRadius:'50%', 
                                            width:40, 
                                            height:40, 
                                            display:'flex', 
                                            justifyContent:'center',
                                            alignItems:'center',
                                        }}
                                        >
                                            <CloseOutlined style={{fontSize:20}} />
                                        </Tag>
                                </EntranceMotion>
                                </div>
                        }
                        offset={[-16, 105]}
                        >
                            <Image src='/cibanners/fail-ticket.png' style={{maxWidth: (globalHelper?.isMobileScreen() ? 120 : 140)}} preview={false}/>
                        </Badge>
                    </EntranceMotion>
                </div>
                
                <div style={{marginTop:12}}>
                    <EntranceMotion initialY={-100} duration={0.5} delay={0.1}>
                        <div>
                            <div>
                                <span className='ticket-label ticket-title h1' style={{fontWeight:'bold',}}>Oh no! Payment Unsuccessful</span>
                            </div>
                            <div>
                                <span style={{fontWeight:500, fontSize:18, color:'var(--secondary-text-color)'}}>We aren't able to proccess your payment. Please try again</span>
                            </div>
                        </div>
                    </EntranceMotion>
                </div>

                <div style={{marginTop:42}}>
                    <div>
                        <Link to="/">
                            <Button type='primary' size='large' style={{color:'var(--main-text-color)', fontWeight:500, minWidth:200}}>Purchase Again</Button>
                        </Link>
                    </div>
                </div>

                <div>
                    <div>
                        <span style={{color:'var(--secondary-text-color)'}}>
                            Reference No : <span style={{fontWeight:500,}}>{ticket?.running_number}</span>
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PaymentResultFail;